var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconDollar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12931_9712",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12931_9712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9056 4.43717C13.9056 4.43717 13.7381 4.26963 13.6543 4.18586C13.047 3.55759 12.2302 3.13874 11.3716 2.99215H11.3297V1.84031C11.3297 1.08639 10.7224 0.5 9.98939 0.5C9.25641 0.5 8.64908 1.08639 8.64908 1.84031V3.01309C7.74855 3.15969 6.91086 3.59948 6.28258 4.29058C5.65431 4.96073 5.25641 5.81937 5.17264 6.74084C5.06792 7.6623 5.27735 8.58377 5.75902 9.35864C6.2407 10.1544 6.97368 10.7618 7.83232 11.0969L11.204 12.3953C11.4972 12.5 11.7276 12.6885 11.9161 12.9398C12.0836 13.1911 12.1674 13.5052 12.1674 13.7984C12.1674 14.2173 11.9999 14.5942 11.7067 14.8874C11.602 14.9921 11.4763 15.0969 11.3297 15.1597C11.1203 15.2644 10.869 15.3272 10.6386 15.3272H9.31923C9.08887 15.3272 8.8585 15.2644 8.64908 15.1597C8.50248 15.0969 8.35588 14.9921 8.25117 14.8874C7.95798 14.5942 7.81138 14.2173 7.79044 13.7984V13.3586C7.79044 12.6047 7.18311 12.0183 6.45012 12.0183C5.71714 12.0183 5.08887 12.6047 5.08887 13.3586V13.8194C5.08887 14.8037 5.44489 15.788 6.0941 16.5419C6.30353 16.7723 6.51295 16.9817 6.76426 17.1702C7.30876 17.589 7.93703 17.8613 8.62813 17.9869H8.64908V19.1597C8.64908 19.8927 9.25641 20.5 9.98939 20.5C10.7224 20.5 11.3297 19.8927 11.3297 19.1597V17.9869C12.2512 17.8194 13.0889 17.3796 13.7171 16.7094C14.3454 16.0393 14.7433 15.1597 14.848 14.2382C14.9318 13.3168 14.7224 12.3953 14.2407 11.5995C13.759 10.8246 13.026 10.2173 12.1465 9.8822L8.77473 8.58377C8.50248 8.47906 8.25117 8.26963 8.08363 8.01832C7.91609 7.76702 7.83232 7.47382 7.83232 7.15969C7.83232 6.76178 7.99986 6.38482 8.29306 6.09162C8.39777 5.98691 8.50248 5.90314 8.64908 5.84031C8.8585 5.71466 9.10981 5.65183 9.36112 5.65183H10.6805C10.9109 5.65183 11.1412 5.71466 11.3297 5.81937C11.4763 5.8822 11.6229 5.98691 11.7486 6.09162C12.0417 6.38482 12.1883 6.76178 12.2093 7.15969V7.99738C12.2093 8.75131 12.8166 9.3377 13.5496 9.3377C14.2826 9.3377 14.9109 8.75131 14.9109 7.99738V7.15969C14.8899 6.17539 14.5339 5.1911 13.9056 4.43717Z",
    fill: "#5849A6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12931_9712)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#5849A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12931_9712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDollar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconDollar.309ca888.svg";
export { ForwardRef as ReactComponent };